<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="foreword" id="_idContainer000" role="doc-foreword">
<p class="pl-fl-header"><b>“Can I help you up?”</b></p>
<p class="fl-fl-roman">Cassie Lynn blinked, coming back to herself, and quickly nodded. “Yes, thank you.” Hoping there was no visible sign of the warmth she felt climbing in her cheeks, she held out her hand.</p>
<p class="fl-fl-roman">He took it in his larger, work-calloused one and placed his other hand behind her back. With surprisingly little effort, the green-eyed stranger had her on her feet in no time. He stepped away once he was certain she was steady, and she found herself missing the gentle strength of his touch.</p>
<p class="fl-fl-roman">He continued to eye her cautiously. “Are you sure you’re okay?”</p>
<p class="fl-fl-roman">Cassie Lynn nodded as she busied herself dusting her skirt. It wasn’t often she found herself flustered this way. “Please don’t worry. I’ve taken worse falls tripping over my own feet.”</p>
<p class="fl-fl-roman">She studied him while trying not to appear to be nosy. There was something about the man that intrigued her. It wasn’t his vivid eyes, or his appearance, though that was appealing enough in a rugged, well-muscled sort of way.</p>
<p class="fl-fl-roman">No, it was something about his demeanor and bearing that commanded her attention.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Introduction.vue?2584d10a